<template>
    <div>
        <div class="example-preview table-responsive">
            <h4 class="card-title card-title--txt">Khóa học đã chọn</h4>
            <table class="table table-vertical-center">
                <tbody class="card-pd">
                <tr v-for="(course_info,index) in contract.student_register_courses" :key="index">
                    <td>
                        {{ course_info.course.name }}
                    </td>
                    <td v-if="!hideCoursePriceEdit">
                        <input v-model="coursePrice[index]" type="number" class="form-control input-course" v-on:input="changeCoursePrice(index)">
                    </td>
                    <td>
                        {{ course_info.course_sale }} %
                    </td>
                    <td>
                        {{ parseInt(course_info.course_fee) * (1 - parseInt(course_info.course_sale) / 100) | toThousandFilter }} ₫
                    </td>
                </tr>
                <tr>
                    <td><strong>Tổng giá khóa (1) :</strong></td>
                    <td :colspan="hideCoursePriceEdit ? 2 : 3" class="text-right">
                        <strong class="text-danger">
                            {{ totalCourseRegisterFee | toThousandFilter }} ₫
                        </strong>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="payment-detail">
            <h5 class="card-title card-title--txt">Chi tiết thanh toán</h5>
            <div class="row" v-if="!isTransferred">
                <div class="col-6">
                    <p>Danh sách khuyến mại:</p>
                </div>
                <div class="col-6">
                    <a href="javascript:" class="promotion-list" @click="showVouchers">
                        <strong>Danh sách Voucher</strong>
                        <span class="promotion-count">{{ promotionTotal }}</span>
                    </a>
                </div>
            </div>
            <div class="row" v-for="(voucher,index) in vouchersForContract" :key="index">
                <div class="col-4">
                    <p>Voucher {{ ++index }}:</p>
                </div>
                <div class="col-4">
                    <span class="promotion-icon" v-if="!isTransferred">
                        <!-- Giảm giá mã Km-->
                        <i v-if="voucher.type !== 0" class="fas fa-minus-circle mr-2" style="cursor: pointer;"  @click="removeContractPromotion(index)"></i>
                        <!-- Voucher type 0-->
                        <i v-else class="fas fa-minus-circle mr-2" style="cursor: pointer;" @click="removeContractVoucher(index)"></i>
                    </span>
                    <span v-if="voucher.type !== 0" class="promotion-list">
                        <strong>{{ 'Quy đổi quà tặng - ' + voucher.name }}</strong>
                    </span>
                    <span v-else class="promotion-list">
                        <strong>{{ voucher.name }}</strong>
                    </span>
                </div>
                <div class="col-4">
                    <strong class="text-danger" v-if="voucher.unit === 1 ">{{ voucher.value | toThousandFilter }}
                        ₫</strong>
                    <strong class="text-danger" v-else>{{ voucher.value }} %</strong>
                </div>
            </div>

            <div class="row border-custom p-3">
                <div class="col-md-6 pb-2">
                    <strong>Tổng khuyến mại (2)</strong>
                </div>
                <div class="col-md-6 pb-2 text-right">
                    <strong>{{ totalDiscount | toThousandFilter }} ₫</strong>
                </div>
                <!-- Gói dịch vụ bảo hành: -->
                <template v-if="isShowWarrantySummary">
                    <div class="col-12 pb-2">
                        <strong>Gói dịch vụ bảo hành</strong>
                    </div>
                    <div class="col-12 mb-2">
                        <div class="row">
                            <div class="col-md-6 d-flex align-items-center">
                                <i class="el-icon-menu mr-2"></i>
                                <strong>{{ contract.service.name }}</strong>
                            </div>
                            <div class="col-md-6 text-right">
                                <strong>{{ warrantyServiceAmount | formatVND }}</strong>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="col-md-6 pb-2 " style="    display: flex; align-items: center;">
                    <strong>Phí huỷ khoá (3)</strong>
                </div>
                <div class="col-md-6 pb-2 text-right">
                    <money style="text-align: right;" v-model="destroy_fee" v-bind="money" @blur.native="changeDestroyFee"
                           class="form-control"/>
                </div>

                <div class="col-md-6 pb-2" v-if="isTransferred">
                    <strong>Khuyến mại sau thay đổi</strong>
                </div>
                <div class="col-md-6 text-right" v-if="isTransferred">
                    <strong>{{ totalPromotionAfterTransferred | toThousandFilter }} ₫</strong>
                </div>
            </div>
            <div class="row p-3">
                <div class="col-md-8 pb-2 d-flex">
                    <strong>Tổng giá trị hợp đồng
                        <span >(4)
                            <i class="fas fa-info-circle" style="cursor: pointer; color: #3a8ee6" v-tooltip="'(4) = (1) - (2) + (3) '"></i>
                        </span>
                    </strong>
                    <span @click="collapse_detail = !collapse_detail">
                        <i class="fas pl-2"
                           :class="{'fa-chevron-down': !collapse_detail, 'fa-chevron-up': collapse_detail}"
                           style="cursor: pointer;  font-size: 12px;"></i>
                    </span>
                </div>
                <div class="col-md-4 pb-2 text-right">
                    <strong>{{ totalPriceContract | toThousandFilter }} ₫</strong>
                </div>
                <div class="col-md-12 pb-2 mt-2" v-if="collapse_detail">
                    <div>Giá khoá học sau khuyến mại</div>
                    <div>
                        <ul class="ml-6">
                            <li v-for="(course_info,index) in courseList" :key="index">
                                <div class="d-flex align-items-center justify-content-between">
                                    <div> {{ course_info.course.name }}</div>
                                    <div class=" pl-2 my-1" style="width: 50%; border-radius: 6px;">
                                        <money @blur.native="blurCheckDiffCourse" style="text-align: right;" v-model="course_info.course_fee_discount_proxy" v-bind="money" class="form-control"/>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6 text-center">
                    <strong>Đã thanh toán
                        <span>(5)</span>
                    </strong>
                </div>
                <div class="col-md-6 text-right">
                    <strong>{{ totalPaidAmount | toThousandFilter }} ₫</strong>
                </div>

                <div class="col-md-6 pt-2">
                    <strong>Còn nợ
                        <span> (6) <i class="fas fa-info-circle" style="cursor: pointer; color: #3a8ee6" v-tooltip="'(6) = (4) - (5)'"></i> </span>
                    </strong>
                </div>
                <div class="col-md-6 pt-2 text-right">
                    <strong>{{ remainingDebtAmount | toThousandFilter }} ₫</strong>
                </div>
            </div>

            <div class="row p-3">
                <div v-if="contract.branch_id" class="col-12 mt-3">
                    <hr style="width: 90%; margin:auto" class="mb-5">
                    <h3>Cách thức thanh toán <span
                        class="text-danger">*</span></h3>
                    <div class="form-group">
                        <div>Chọn cách thức thanh toán <span class="text-danger">*</span></div>
                        <div class="payment-method-group">
                            <div
                                class="payment-option mb-2"
                                v-for="item in methodPayment"
                                :key="item.id"
                            >
                                <div class="d-flex align-items-center" style="gap: 10px;">
                                    <div class="payment-checkbox">
                                        <el-checkbox
                                            :label="item.id"
                                            v-model="method_payment_id"
                                            @change="handleChangeMethodPayment"
                                        >
                                            {{ item.name }}
                                        </el-checkbox>
                                    </div>

                                    <el-input
                                        v-if="item.id === 3 && method_payment_id?.includes(3)"
                                        placeholder="Nhập số tiền thanh toán"
                                        v-model="inputPaymentAmount"
                                        class="payment-input"
                                        type="text"
                                    />
                                </div>

                                <div
                                    v-if="item.id === 3 && method_payment_id?.includes(3) && remainingDebtAmount > 0"
                                    class="quick-amount-group d-flex flex-wrap align-items-center mt-2 ml-4"
                                    style="gap: 6px;"
                                >
                                    <button
                                        v-for="opt in QUICK_PERCENT_OPTIONS"
                                        :key="opt.percent"
                                        type="button"
                                        class="btn btn-sm d-flex align-items-center py-1 px-2"
                                        :class="contract.payment_amount === getQuickAmount(opt.percent, remainingDebtAmount) ? 'btn-primary text-white font-weight-bold' : 'btn-outline-secondary bg-white'"
                                        style="font-size: 12px; border-radius: 6px; gap: 4px;"
                                        @click="setQuickPaymentAmount(getQuickAmount(opt.percent, remainingDebtAmount))"
                                    >
                                        <span>{{ opt.label }}</span>
                                        <span>·</span>
                                        <span>{{ getQuickAmount(opt.percent, remainingDebtAmount) | toThousandFilter }} đ</span>
                                    </button>
                                </div>
                            </div>

                            <div v-if="method_payment_id?.includes(ONEPAY_METHOD_ID)" class="onepay-detail mt-3 pl-3">
                                <div class="form-group mb-3">
                                    <div class="font-weight-bold mb-2">
                                        MỤC ĐÍCH THANH TOÁN <span class="text-danger">*</span>
                                    </div>
                                    <div style="display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px;">
                                        <label
                                            v-for="opt in visibleOnePayInstallmentOptions"
                                            :key="opt.value"
                                            class="d-flex align-items-center p-2 rounded border cursor-pointer mb-0"
                                            :class="onepay_installment === opt.value ? 'border-primary bg-light-primary font-weight-bold' : 'border-light bg-white'"
                                            style="transition: all 0.2s;"
                                        >
                                            <el-radio
                                                v-model="onepay_installment"
                                                :label="opt.value"
                                                class="mb-0"
                                                @change="syncOnePayToContract"
                                            >
                                                {{ opt.label }}
                                            </el-radio>
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group mb-3">
                                    <div class="font-weight-bold mb-2">
                                        SỐ TIỀN KHÁCH HÀNG THANH TOÁN <span class="text-danger">*</span>
                                    </div>

                                    <div
                                        v-if="remainingDebtAmount > 0"
                                        class="quick-amount-group d-flex flex-wrap align-items-center mb-2"
                                        style="gap: 6px;"
                                    >
                                        <button
                                            v-for="opt in QUICK_PERCENT_OPTIONS"
                                            :key="opt.percent"
                                            type="button"
                                            class="btn btn-sm d-flex align-items-center py-1 px-2"
                                            :class="contract.onepay_amount === getQuickAmount(opt.percent, remainingDebtAmount) ? 'btn-primary text-white font-weight-bold' : 'btn-outline-secondary bg-white'"
                                            style="font-size: 12px; border-radius: 6px; gap: 4px;"
                                            @click="setQuickOnepayAmount(getQuickAmount(opt.percent, remainingDebtAmount))"
                                        >
                                            <span>{{ opt.label }}</span>
                                            <span>·</span>
                                            <span>{{ getQuickAmount(opt.percent, remainingDebtAmount) | toThousandFilter }} đ</span>
                                        </button>
                                    </div>

                                    <el-input
                                        v-model="inputOnepayAmount"
                                        placeholder="Nhập số tiền"
                                        class="payment-input"
                                        type="text"
                                    >
                                        <template slot="append">đ</template>
                                    </el-input>
                                </div>
                                <div v-if="onepayNotice" class="alert alert-warning py-2 px-3 mb-3 text-sm" style="font-size: 13px;">
                                    <i class="el-icon-warning mr-1"></i>
                                    <span>{{ onepayNotice }}</span>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <div class="border rounded p-3 bg-white">
                                            <small class="text-muted d-block mb-1">Phí trả góp / phụ phí</small>
                                            <div class="font-weight-bold text-dark font-size-h6">
                                                {{ formatCurrency(onepayInstallmentFee) }} đ
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <div class="border border-primary rounded p-3 bg-light-primary">
                                            <small class="text-muted d-block mb-1">Tổng cần thanh toán</small>
                                            <div class="font-weight-bold font-size-h6 text-primary">
                                                {{ formatCurrency(onepayCardAmount) }} đ
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="method_payment_id?.includes(3) || method_payment_id?.includes(ONEPAY_METHOD_ID)">
                        <el-button @click="showDialogInstruct=true" size="mini" style="background-color: #1BC5BD;"
                                   class="text-white rounded float-right">Xem hướng dẫn thanh toán
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <list-course-refund :show-modal="showModalListCourses" @clicked="closeModalListCourses"
                            :list-courses-refund="coursesRefund"></list-course-refund>

        <el-dialog :visible.sync="showDialogInstruct" append-to-body width="40%">
            <div class="box-instruct" v-if="method_payment_id?.length">
                <h4 style="font-weight: 600; color: black" class="mb-3">Hướng dẫn thanh toán:</h4>
                <h5 class="mb-3" v-if="contract.payment_amount">Cách thức thanh toán: Chuyển khoản - Số tiền:
                    <span> {{ formatCurrency(contract.payment_amount) }} </span>đ</h5>
                <div v-if="method_payment_id?.includes(3) && paymentOption" class="mb-3">
                    <h5>- Thanh toán bằng chuyển khoản</h5>
                    <div style="line-height: 2">
                        <span>Bước 1: Chuyển khoản theo thông tin chi tiết {{ centerName }} cung cấp:</span><br>
                        <span>Bạn có thể gửi mã QR này cho khách hàng:</span><br>
                        <div class="qr-code d-flex justify-content-center">
                            <div>
                                <img style="width:280px" class="mr-4" :src="qrCode" alt="QR Code"/>
                            </div>
                            <div style="word-break: auto-phrase">
                                <span>- Ngân hàng {{ paymentOption?.bank_name }}</span><br>
                                <span>- Chủ tài khoản: {{ paymentOption?.bank_account_name }} </span><br>
                                <span>- Số tài khoản: {{ paymentOption?.bank_account_number }}</span><br>
                                <span>- Nội dung chuyển khoản: {{ prefix }}{{
                                        paymentOption.payment_code
                                    }} {{ contract?.customer?.phone }}</span><br>

                                <div>
                                    <el-checkbox
                                        v-if="paymentOption"
                                        v-model="checkedEditAccount"
                                        @change="openDialogChangeAccount"
                                    >
                                        Khách hàng muốn thay đổi tài khoản thanh toán
                                    </el-checkbox>
                                </div>
                            </div>
                        </div>
                        <div style="word-break: auto-phrase">
                            <span>Bước 2: Hoàn tất thông tin sau tin nhắn xác nhận chuyển tiền</span><br>
                            <span>{{ centerName }} sẽ nhắn tin tới số điện thoại khách hàng cung cấp trong nội dung
chuyển khoản để xác nhận thông tin chuyển tiền muộn nhất trong vòng 4h
(theo giờ hành chính) sau khi nhận được tiền. Trường hợp không nhận được
tin nhắn, bạn vui lòng báo khách hàng vui lòng liên hệ qua tổng đài 1900 4782
để được xử lý.</span><br>
                            <span>{{ centerName }} không chịu trách nhiệm nếu trong quá trình chuyển khoản sai thông tin.
Trong một số tình huống cụ thể, khách hàng có thể nhờ phía Ngân hàng thực hiện
chuyển khoản hoặc Ngân hàng thụ hưởng của {{ centerName }} để kiểm tra đối chứng cần thiết. Ngay khi nhận được xác nhận từ Ngân hàng, {{
                                    centerName
                                }} sẽ tiến hành thủ tục tiếp theo cho Khách hàng.</span><br>
                        </div>
                    </div>
                </div>

                <div style="line-height: 2; word-break: auto-phrase"
                     v-if="[1, 2].some(id => method_payment_id?.includes(id))">
                    <h5>- Thanh toán bằng tiền mặt</h5>
                    <span>Nộp học phí trực tiếp tại hệ thống Trung tâm {{ centerName }}</span><br>
                    <span>Thời gian: từ 14h00 đến 21h00 các ngày từ thứ 2 tới thứ 7 hàng tuần (trừ ngày lễ, tết theo quy định Nhà nước).</span><br>
                    <span>Khi đến văn phòng giao dịch thuộc văn phòng {{ centerName }}, học viên sẽ được nhân viên  hướng dẫn các bước thanh toán.</span>
                </div>

                <div
                    v-if="method_payment_id?.includes(ONEPAY_METHOD_ID)"
                    class="mb-3"
                    style="line-height: 2; word-break: auto-phrase"
                >
                    <h5>HƯỚNG DẪN THANH TOÁN ONEPAY</h5>
                    <div>
                        <strong>Bước 1.</strong> Nhận link thanh toán Onepay trên phiếu đăng ký học tập<br>
                        Kiểm tra nội dung hóa đơn và chọn “I agreed with Terms and Conditions”, chọn CHECK OUT TO PAY để thực hiện thanh toán
                    </div>
                    <div class="mt-2">
                        <strong>Bước 2.</strong> Nhập thông tin thẻ<br>
                        Khách hàng điền thông tin thẻ và nhấn nút Process Payment để thực hiện thanh toán
                    </div>
                    <div class="mt-2">
                        <strong>Lưu ý:</strong> Nếu thẻ có tham gia chương trình xác thực 3D-Secure thì sau khi nhập thông tin thẻ. Ngân hàng sẽ yêu cầu nhập thêm mật khẩu
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button style="background-color: #CACACA;" class="text-black" @click="showDialogInstruct = false">
                    Đóng
                </el-button>
            </div>
        </el-dialog>

        <b-modal
            style="z-index: 10000000"
            id="change-account-modal"
            v-model="dialogChangeAccount"
            append-to-body
            title="Phiếu đăng ký thay đổi tài khoản thanh toán"
            centered
            hide-footer
            size="xl"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            body-class="pb-0"
        >
            <ValidationObserver v-slot="{ invalid, handleSubmit }">
                <b-form @submit.prevent="handleSubmit(onSubmit)">
                    <b-row>
                        <b-col cols="12" md="6">
                            <ValidationProvider name="Tên khách hàng" rules="" v-slot="{ errors }">
                                <b-form-group label="Tên khách hàng" label-for="name" :state="!errors[0]"
                                              description="">
                                    <b-form-input id="name" disabled v-model="contract.customer.name"
                                                  placeholder="Nguyễn Thị Tuyết Nhung"/>
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>

                        <b-col cols="12" md="6">
                            <ValidationProvider name="Ngày sinh" rules="" v-slot="{ errors }">
                                <b-form-group label="Ngày sinh" label-for="birthday" :state="!errors[0]">
                                    <b-form-input id="birthday" disabled v-model="contract.customer.ngay_sinh"
                                                  placeholder="Nhập ngày sinh"/>
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>

                        <b-col cols="12" md="6">
                            <ValidationProvider name="Số điện thoại" rules="" v-slot="{ errors }">
                                <b-form-group label="Số điện thoại" label-for="phone" :state="!errors[0]">
                                    <b-form-input id="phone" disabled v-model="contract.customer.phone"
                                                  placeholder="Nhập số điện thoại"/>
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>

                        <b-col cols="12" md="6">
                            <ValidationProvider name="Email" rules="" v-slot="{ errors }">
                                <b-form-group label="Email" label-for="email" :state="!errors[0]">
                                    <b-form-input id="email" disabled v-model="contract.customer.email"
                                                  placeholder="Nhập email"/>
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>

                        <b-col cols="12">
                            <ValidationProvider name="Lý do thay đổi" rules="required" v-slot="{ errors }">
                                <b-form-group
                                    label="Lý do thay đổi tài khoản thanh toán*"
                                    label-for="reason"
                                    :state="!errors[0]"
                                >
                                    <b-form-textarea
                                        id="reason"
                                        v-model="reason"
                                        placeholder="Nhập lý do"
                                        rows="4"
                                        max-rows="6"
                                    />
                                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>

                    <div class="text-right pb-3">
                        <b-button variant="secondary" @click="dialogChangeAccount = false">Huỷ bỏ</b-button>
                        <b-button class="ml-2" variant="primary" type="submit" :disabled="loadingDestination"><i
                            :class="loadingDestination ? 'el-icon-loading' : ''"></i>Lưu thông tin
                        </b-button>
                    </div>
                </b-form>
            </ValidationObserver>
        </b-modal>
    </div>
</template>

<script>
import ListCourseRefund from "./ListCourseRefund";
import {CHANGE_DESTINATION, GET_RATIO_PAYMENT} from "../../../../core/services/store/contract/contracts.module";
import {Money} from 'v-money';
import {isWarrantyServiceCenter} from "@/core/config/center/centerOption";
import {
    ONEPAY_METHOD_ID,
    ONEPAY_INSTALLMENT,
    getVisibleInstallmentOptions,
    calcOnePayInstallmentFee,
    calcOnePayCardAmount,
    getOnePayFeePercent,
    getOnePayNotice,
    buildPaymentOptionLabel,
} from "@/core/option/onePayOption";

export default {
    name: "PaymentDetail",
    components: {
        ListCourseRefund,
        Money
    },
    props: {
        contract: {
            type: Object,
            default: () => {
                return {}
            }
        },
        isWithdrawWithCourse: {
            default: false
        },
        promotionForContract: {
            type: [Object, String, Array],
            default: () => {
                return ''
            }
        },
        vouchersForContract: {
            type: Array,
            default: () => {
                return []
            }
        },
        tuitionPaymentId: {
            type: [Number, String],
            default: null,
        },
        coursePrice: {
            type: [Array],
            default: () => {
                return []
            }
        },
        hideCoursePriceEdit: {
            type: Boolean,
            default: false,
        },
        promotions: {
            type: [Array],
            default: () => {
                return []
            }
        },
        vouchers: {
            type: [Array],
            default: () => {
                return []
            }
        },
        totalDiscount: {
            type: [String, Number],
            default: () => {
                return 0
            }
        },
        totalCourseRefundFee: {
            type: [String, Number],
            default: () => {
                return 0
            }
        },
        totalDestroyFee: {
            type: [String, Number],
            default: () => {
                return 0
            }
        },
        totalCourseRegisterFee: {
            type: [String, Number],
            default: () => {
                return 0
            }
        },
        totalContractAmount: {
            type: [String, Number],
            default: () => {
                return 0
            }
        },
        coursesRefund: {
            type: [Array],
            default: () => {
                return []
            }
        },
        isTransferred: {
            type: Boolean,
            default: () => {
                return false
            }
        },
        totalPromotionAfterTransferred: {
            type: Number,
            default: () => {
                return 0
            }
        },
        gifts: {
            type: Array,
            default: () => {
                return []
            }
        },
        promotionTotal: {
            type: Number,
            default: () => {
                return 0
            }
        },
    },
    data() {
        return {
            showModalListCourses: false,
            prefix: '',
            centerName: '',
            checkedEditAccount: false,
            qrCode: '',
            showDialogInstruct: false,
            dialogChangeAccount: false,
            loadingDestination: false,
            reason: '',
            inputPaymentAmount: '',
            QUICK_PERCENT_OPTIONS: [
                { label: 'Toàn bộ', percent: 1 },
                { label: '50%', percent: 0.5 },
                { label: '30%', percent: 0.3 }
            ],
            destroy_fee: 0,
            currentTime: '',
            loadingAccept: false,
            method_payment_id: [],
            paymentOption: [],
            collapse_detail: false,
            ONEPAY_METHOD_ID,
            onepay_installment: 0,
            inputOnepayAmount: '',
            onepayInstallmentOptions: [
                {value: 0, label: 'Trả thẳng'},
                {value: 6, label: 'Trả góp trong 6 tháng'},
                {value: 9, label: 'Trả góp trong 9 tháng'},
                {value: 12, label: 'Trả góp trong 12 tháng'},
            ],
            methodPayment: [
                {id: 1, name: 'Tiền mặt'},
                {id: 2, name: 'Quẹt thẻ'},
                {id: 3, name: 'Chuyển khoản'},
                {id: ONEPAY_METHOD_ID, name: 'OnePay'},
            ],
            money: {
                decimal: ',',
                thousands: ',',
                prefix: '',
                suffix: ' VNĐ',
                precision: 0,
                masked: false,
            },
        }
    },
    mounted() {
        if (this.contract?.payment_options) {
            this.paymentOption = this.contract?.payment_options;
        }
        this.destroy_fee = this.totalDestroyFee;
        this.restorePaymentMethodSelection();
    },
    computed: {
        totalPaidAmount() {
            return (Number(this.contract.total_paid) || 0);
        },
        remainingDebtAmount() {
            return (Number(this.totalPriceContract) || 0)
                - this.totalPaidAmount;
        },
        isShowWarrantySummary() {
            return isWarrantyServiceCenter(this.contract.center_id) && !!this.contract.service_id;
        },
        warrantyServiceAmount() {
            if (!this.contract.service) {
                return 0;
            }

            const total = Number(this.contract.total) || 0;
            const percent = Number(
                this.contract.service.percent_price != null
                    ? this.contract.service.percent_price
                    : this.contract.service.percent
            ) || 0;

            return (total * percent) / 100;
        },
        totalPriceContract() {
            return this.totalCourseRegisterFee - this.totalDiscount + this.destroy_fee + this.contract.service_total;
        },
        totalCourseAfterDiscount () {
            return this.contract.student_register_courses.reduce((sum, item) => sum + item.course_fee_discount, 0);
        },
        courseList() {
            const self = this;
            const destroy_fee = self.destroy_fee;
            const totalContract = this.totalCourseRegisterFee - this.totalDiscount + this.destroy_fee;
            const totalCourseFeeDiscount = this.contract.student_register_courses.reduce((sum, item) => sum + item.course_fee_discount, 0);
            return this.contract.student_register_courses.map(course_info => ({
                ...course_info,
                get course_fee_discount_proxy() {
                    if (self.isWithdrawWithCourse || totalCourseFeeDiscount !== totalContract) {
                        let percent = parseInt(course_info.course_fee) / self.totalCourseRegisterFee;
                        if (self.destroy_fee > 0) {
                            return parseInt(course_info.course_fee) - parseInt(percent * self.totalDiscount) + parseInt(percent * destroy_fee);
                        }
                        return parseInt(course_info.course_fee) - (percent) * self.totalDiscount;
                    } else {
                        return parseInt(course_info.course_fee_discount);
                    }
                },
                set course_fee_discount_proxy(val) {
                    course_info.course_fee_discount = val;
                }
            }));
        },
        visibleOnePayInstallmentOptions() {
            const tuitionId = this.tuitionPaymentId ?? this.contract?.tuition_payment_id;
            return getVisibleInstallmentOptions(tuitionId);
        },
        onepayFeePercent() {
            const tuitionId = this.tuitionPaymentId ?? this.contract?.tuition_payment_id;
            return getOnePayFeePercent(this.onepay_installment, this.vouchersForContract, tuitionId);
        },
        onepayNotice() {
            return getOnePayNotice(this.onepay_installment, this.onepayFeePercent);
        },
        onepayInputAmount() {
            const raw = (this.inputOnepayAmount || '').toString().replace(/\./g, '').replace(/\D/g, '');
            const parsed = raw ? parseInt(raw, 10) : 0;
            return parsed || Number(this.contract?.onepay_amount) || 0;
        },
        onepayInstallmentFee() {
            if (!this.method_payment_id?.includes(this.ONEPAY_METHOD_ID)) return 0;
            return calcOnePayInstallmentFee(this.onepayInputAmount, this.onepayFeePercent);
        },
        onepayCardAmount() {
            if (!this.method_payment_id?.includes(this.ONEPAY_METHOD_ID)) return 0;
            return calcOnePayCardAmount(this.onepayInputAmount, this.onepayInstallmentFee);
        },
    },

    //2953320
    watch: {
        inputPaymentAmount(val) {
            const need_money = (this.totalCourseRegisterFee + this.contract.service_total - this.totalDiscount) - (this.contract.total_paid);
            const raw = (val || '').toString().replace(/\./g, '').replace(/\D/g, '');
            const amount = raw ? parseInt(raw, 10) : 0;
            if (amount > need_money) {
                this.$notify({
                    title: 'Sai dữ liệu!',
                    message: 'Số tiền chuyển khoản đã vượt quá số tiền cần đóng',
                    type: 'warning'
                });
                this.inputPaymentAmount = 0;
                return;
            }
            this.contract.payment_amount = amount;

            // Cập nhật QR code
            const rawQr = this.qrCode || '';
            const cleanedQr = rawQr.replace(/([&?])amount=\d+/, '');
            const separator = cleanedQr.includes('?') ? '&' : '?';
            this.qrCode = `${cleanedQr}${separator}amount=${amount}`;

        // Cập nhật lại v-model hiển thị
            this.inputPaymentAmount = amount.toLocaleString('vi-VN');
        },
        inputOnepayAmount(val) {
            const need_money = (this.totalCourseRegisterFee + this.contract.service_total - this.totalDiscount) - (this.contract.total_paid);
            const raw = (val || '').toString().replace(/\./g, '').replace(/\D/g, '');
            const amount = raw ? parseInt(raw, 10) : 0;
            if (amount > need_money) {
                this.$notify({
                    title: 'Sai dữ liệu!',
                    message: 'Số tiền OnePay đã vượt quá số tiền cần đóng',
                    type: 'warning'
                });
                this.inputOnepayAmount = 0;
                return;
            }
            this.contract.onepay_amount = amount;
            this.inputOnepayAmount = amount ? amount.toLocaleString('vi-VN') : '';
            this.syncOnePayToContract();
        },
        'contract.payment_amount': {
            immediate: true,
            handler(val) {
                this.inputPaymentAmount = val ? val.toLocaleString('vi-VN') : '';
            }
        },
        'contract.onepay_amount': {
            immediate: true,
            handler(val) {
                this.inputOnepayAmount = val ? Number(val).toLocaleString('vi-VN') : '';
            }
        },

        dialogChangeAccount(newVal) {
            this.checkedEditAccount = newVal;
            if (!newVal) {
                this.showDialogInstruct = true;
            }
        },
        totalDestroyFee(newVal) {
            this.destroy_fee = newVal;
        },
        vouchersForContract: {
            deep: true,
            handler() {
                if (this.method_payment_id?.includes(this.ONEPAY_METHOD_ID)) {
                    this.syncOnePayToContract();
                }
            }
        },
        tuitionPaymentId() {
            if (this.method_payment_id?.includes(this.ONEPAY_METHOD_ID)) {
                this.syncOnePayToContract();
            }
        },
        onepay_installment() {
            if (this.method_payment_id?.includes(this.ONEPAY_METHOD_ID)) {
                this.syncOnePayToContract();
            }
        },
        onepayInstallmentFee() {
            if (this.method_payment_id?.includes(this.ONEPAY_METHOD_ID)) {
                this.syncOnePayToContract();
            }
        },
    },
    methods: {
        blurCheckDiffCourse() {
            if (this.totalPriceContract !== this.totalCourseAfterDiscount) {
                this.$notify({
                    title: 'Có lỗi xảy ra!',
                    message: 'Tổng giá sau khuyến mại của các khóa học phải bằng Tổng giá trị hợp đồng ',
                    type: 'warning',
                });
                this.$emit('disableButtonSave', true)
            } else {
                this.$emit('disableButtonSave', false)
            }
        },
        formatCurrency(amount) {
            const num = Number(amount);
            return isNaN(num) ? amount : num.toLocaleString('vi-VN');
        },
        showGifts() {
            this.$emit('showPromotions')
        },
        showVouchers() {
            this.$emit('showVouchers')
        },
        removeContractPromotion(index) {
            this.$emit('removeContractPromotion', index);
        },
        removeContractVoucher(index) {
            this.$emit('removeContractVoucher', index);
        },
        changeCoursePrice(index) {
            this.$emit('changeCoursePrice', index);
        },
        changeDestroyFee() {
            this.$emit('changeDestroyFee', this.destroy_fee);
        },
        openModalListCourses: function () {
            this.showModalListCourses = true;
        },
        closeModalListCourses: function () {
            this.showModalListCourses = false;
        },
        restorePaymentMethodSelection() {
            if (Array.isArray(this.contract?.method_payment_id) && this.contract.method_payment_id.length) {
                this.method_payment_id = [...this.contract.method_payment_id];
            } else if (this.contract?.payment_option) {
                const names = String(this.contract.payment_option)
                    .split(',')
                    .map(s => s.trim())
                    .filter(Boolean);
                this.method_payment_id = this.methodPayment
                    .filter(item => names.includes(item.name))
                    .map(item => item.id);
            }

            if (this.contract?.onepay_installment != null && this.contract.onepay_installment !== '') {
                this.onepay_installment = Number(this.contract.onepay_installment);
            }
            if (this.contract?.onepay_amount) {
                this.inputOnepayAmount = Number(this.contract.onepay_amount).toLocaleString('vi-VN');
            }
            this.syncPaymentOption();
        },
        syncPaymentOption() {
            this.contract.method_payment_id = [...(this.method_payment_id || [])];
            const tuitionId = this.tuitionPaymentId ?? this.contract?.tuition_payment_id;
            if (Number(tuitionId) !== 2 && this.onepay_installment !== 0) {
                this.onepay_installment = 0;
            }
            this.contract.payment_option = buildPaymentOptionLabel(
                this.method_payment_id,
                this.methodPayment,
                this.onepay_installment
            );
            this.syncOnePayToContract();
        },
        syncOnePayToContract() {
            if (!this.method_payment_id?.includes(this.ONEPAY_METHOD_ID)) {
                this.contract.onepay_installment = null;
                this.contract.onepay_amount = null;
                this.contract.onepay_card_amount = null;
                this.contract.installments_number = null;
                return;
            }
            const tuitionId = this.tuitionPaymentId ?? this.contract?.tuition_payment_id;
            if (Number(tuitionId) !== 2 && this.onepay_installment !== 0) {
                this.onepay_installment = 0;
            }
            this.contract.onepay_installment = this.onepay_installment;
            this.contract.onepay_amount = this.onepayInputAmount;
            this.contract.onepay_card_amount = this.onepayCardAmount;
            this.contract.installments_number = this.onepayFeePercent;
            this.contract.payment_option = buildPaymentOptionLabel(
                this.method_payment_id,
                this.methodPayment,
                this.onepay_installment
            );
        },
        async handleChangeMethodPayment() {
            this.prefix = this.contract.center_id === 295 ? 'EC' : 'IE';
            this.centerName = this.prefix == 'EC' ? 'ECoach' : 'IELTS Mentor';
            if (this.paymentOption) {
                this.qrCode = `https://qr.sepay.vn/img?bank=${this.paymentOption?.bank_name.trim()}&acc=${this.paymentOption?.bank_account_number.trim()}&template=compact&des=${this.prefix}${this.paymentOption?.payment_code.trim()}${' ' + this.contract?.customer?.phone}`
            } else {
                if (this.method_payment_id?.includes(3)) {
                    await this.$store.dispatch(GET_RATIO_PAYMENT, {
                        branch_id: this.contract.branch_id,
                        contract_id: this.contract.id
                    }).then((data) => {
                        if (!data.data) {
                            this.contract.method_payment_id = '';
                            this.$notify({
                                title: 'Không tìm thấy phương thức thanh toán!',
                                message: 'Thất bại!',
                                type: 'error'
                            });
                        }
                        ;

                        this.paymentOption = data?.data;
                        this.qrCode = `https://qr.sepay.vn/img?bank=${this.paymentOption?.bank.trim()}&acc=${this.paymentOption?.account_number.trim()}&template=compact&des=${this.prefix}${this.paymentOption?.payment_code.trim()}${' ' + this.contract?.customer?.phone}`
                    });
                }
                ;
            }

            this.syncPaymentOption();

            if (!this.method_payment_id.includes(3)) {
                this.contract.payment_amount = '';
                this.inputPaymentAmount = '';
            }

            if (!this.method_payment_id.includes(this.ONEPAY_METHOD_ID)) {
                this.onepay_installment = 0;
                this.inputOnepayAmount = '';
                this.contract.onepay_installment = null;
                this.contract.onepay_amount = null;
                this.contract.onepay_card_amount = null;
                this.contract.installments_number = null;
            } else if (this.onepay_installment == null || this.onepay_installment === '') {
                this.onepay_installment = 0;
                this.syncOnePayToContract();
            }
        },


        openDialogChangeAccount(val) {
            if (val) {
                this.showDialogInstruct = false;
            }
            this.dialogChangeAccount = !!val;
        },

        onSubmit() {
            if ((this.reason?.length ?? 0) < 200) {
                this.$notify({
                    title: 'Có lỗi xảy ra!',
                    message: 'Lý do thay đổi tài khoản thanh toán phải tối thiểu 200 ký tự',
                    type: 'warning',
                });
                return;
            }
            this.loadingDestination = true;
            const payload = {
                branch_id: this.contract.branch_id,
                payment_option_id: this.contract?.payment_options?.id,
                transferDestination: this.contract.payment_options.transfer_destination,
                contract_id: this.contract.id,
                reason: this.reason,
                amount: this.contract,
            }
            this.$store.dispatch(CHANGE_DESTINATION, payload).then((res) => {
                this.reason = '';
                if (res.data) {
                    this.$notify({
                        title: 'Thay đổi tài khoản thanh toán thành công!',
                        message: 'Thất bại!',
                        type: 'success'
                    });
                    this.paymentOption = res.data;
                    this.qrCode = `https://qr.sepay.vn/img?bank=${this.paymentOption?.bank_name.trim()}&acc=${this.paymentOption?.bank_account_number.trim()}&template=compact&des=${this.prefix}${this.paymentOption?.payment_code.trim()}${' ' + this.contract?.customer?.phone}`;
                    if (this.contract.payment_amount > 0 && this.paymentOption) {
                        this.qrCode += `&amount=${this.contract.payment_amount}`;
                    }
                    this.dialogChangeAccount = false;
                    this.showDialogInstruct = false;
                    this.loadingDestination = false;
                }
            });
        },
        getQuickAmount(percent, total) {
            return Math.round((Number(total) || 0) * percent);
        },
        setQuickPaymentAmount(amount) {
            const maxAmount = Math.max(0, this.remainingDebtAmount);
            const finalAmount = amount > maxAmount && maxAmount > 0 ? maxAmount : amount;
            this.contract.payment_amount = finalAmount;
            this.inputPaymentAmount = finalAmount ? finalAmount.toLocaleString('vi-VN') : '';
        },
        setQuickOnepayAmount(amount) {
            const maxAmount = Math.max(0, this.remainingDebtAmount);
            const finalAmount = amount > maxAmount && maxAmount > 0 ? maxAmount : amount;
            this.contract.onepay_amount = finalAmount;
            this.inputOnepayAmount = finalAmount ? finalAmount.toLocaleString('vi-VN') : '';
            this.syncOnePayToContract();
        },
    }
}
</script>

<style scoped>
.onepay-detail {
    border-left: 3px solid #409EFF;
    background: #f8fbff;
    padding: 12px 16px;
    border-radius: 0 6px 6px 0;
}

.loading-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 250px; /* đảm bảo có chiều cao để căn giữa */
}

.dot-ring-loader {
    display: inline-block;
    position: relative;
    width: 40px;
    height: 40px;
}

.dot-ring-loader div {
    position: absolute;
    width: 6px;
    height: 6px;
    background: #f2c94c;
    border-radius: 50%;
    animation: dot-ring-spin 1.2s linear infinite;
}

.dot-ring-loader div:nth-child(1) {
    top: 0px;
    left: 18px;
    animation-delay: 0s;
}

.dot-ring-loader div:nth-child(2) {
    top: 5px;
    left: 28px;
    animation-delay: -0.1s;
}

.dot-ring-loader div:nth-child(3) {
    top: 14px;
    left: 32px;
    animation-delay: -0.2s;
}

.dot-ring-loader div:nth-child(4) {
    top: 23px;
    left: 28px;
    animation-delay: -0.3s;
}

.dot-ring-loader div:nth-child(5) {
    top: 28px;
    left: 18px;
    animation-delay: -0.4s;
}

.dot-ring-loader div:nth-child(6) {
    top: 23px;
    left: 5px;
    animation-delay: -0.5s;
}

.dot-ring-loader div:nth-child(7) {
    top: 14px;
    left: 0px;
    animation-delay: -0.6s;
}

.dot-ring-loader div:nth-child(8) {
    top: 5px;
    left: 5px;
    animation-delay: -0.7s;
}

@keyframes dot-ring-spin {
    0% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(0.5);
        opacity: 0.3;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}
</style>

